import { HashRouter as Router } from "react-router-dom";
import App from "./App";

const AppRouter = () => (
  <Router>
    <App />
  </Router>
);

export default AppRouter;
